<template>
    <div>
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>内容管理</el-breadcrumb-item>
          <el-breadcrumb-item>banner管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="operating">
        <span> <el-button type="primary" size="small" @click="addDialog" >新增banner</el-button></span>
      </div>
      <div>
        <template>
          <el-table
            :data="tableData"
            stripe
            center
            border
            highlight-current-row
            @sort-change="changeColumnSort"
            style="width: 100%">
            <el-table-column
              align="center"
              label="排序"
              width="80"
              prop="sort"
              sortable="custom">
              <template slot-scope="scope">
                <el-input  size="small" v-model="scope.row.sort"  :min="0" :max="1000" @change="changeSort(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="位置"
              prop="position"
              sortable="custom">
              <template slot-scope="scope">
                <div>{{ scope.row.position | arrayGetValue({1:"首页头部",2:"游戏中心",3:"视频中心",4:"移动端"})}}</div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="标题"
              prop="title">
            </el-table-column>
            <el-table-column
              align="center"
              label="预览图">
              <template slot-scope="scope">
                <el-image :src="scope.row.img_url" alt="" :preview-src-list="[scope.row.img_url]" style="height: 40px; width: 40px">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="跳转链接"
              prop="jump_link">
            </el-table-column>
            <el-table-column
              align="center"
              label="创建时间"
              prop="created_time"
              sortable="custom">
              <template slot-scope="scope">
                <div>{{ scope.row.created_time | formatDate}}</div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="最后编辑时间"
              prop="updated_time"
              sortable="custom">
              <template slot-scope="scope">
                <div>{{ scope.row.updated_time | formatDate}}</div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="是否可见">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.is_visible?'可见':'不可见'" placement="top">
                  <el-switch
                    v-model="scope.row.is_visible"
                    @change="handleChangeStatus(scope.row, 'is_visible','is_visible')"
                    active-color="#13ce66"
                    inactive-color="#DCDFE6">
                  </el-switch>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="操作"
              width="140">
              <template slot-scope="scope" >
                <el-button
                  type="primary"
                  size="small"
                  @click="editDialog(scope.row.id)">编辑
                </el-button>
                <el-popconfirm
                  confirmButtonText='确定'
                  cancelButtonText='返回'
                  icon="el-icon-info"
                  iconColor="red"
                  title="删除不可恢复，确定删除吗？"
                  @onConfirm="del(scope.row.id)"
                >
                  <el-button type="primary"  size="small" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <div class="block page-box">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page=page
              :page-sizes="[50, 100, 200, 500]"
              :page-size=page_size
              layout="total, sizes, prev, pager, next, jumper"
              :total=total>
            </el-pagination>
          </div>
        </template>
      </div>
      <el-dialog :title="dialogTitle" :visible.sync="dialogAddVisible" :close-on-click-modal="false" width="600px" class="padding_10">
        <el-form :model="addForm"  :rules="rules" label-width="120px"  ref="addForm">
          <el-form-item label="banner标题" prop="title" >
            <el-input v-model="addForm.title" auto-complete="off" placeholder="请输入banner标题"></el-input>
          </el-form-item>
          <el-form-item label="位置" prop="position" >
            <el-select v-model="addForm.position" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in position"
                :key="item.id"
                :label="item.value"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跳转链接" prop="jump_link" >
            <el-input v-model="addForm.jump_link" auto-complete="off" placeholder="请输入跳转链接"></el-input>
          </el-form-item>
          <el-form-item label="图片" prop="file_id"  style="text-align: left!important;">
            <el-upload
              class="upload-demo"
              action="#"
              :limit="100"
              :on-change="handleChange"
              :http-request="uploadImg"
              list-type="picture"
              :file-list="fileList"
              :on-remove="handleRemove"
              ref="add_upload"
              prop="file_id">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" style="color: red;font-size: 14px;margin-left: 8px" class="el-upload__tip">首页头部1920*845  移动端750*1175 其他页面1920*669 </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" :loading="addLoading" @click="addBanner('addForm')">保 存</el-button>
          <el-button size="small" @click="callOf('addForm')">取 消</el-button>
        </div>
      </el-dialog>
      <el-dialog :title="dialogTitle" :visible.sync="dialogEditVisible" :close-on-click-modal="false" width="600px" class="padding_10">
        <el-form :model="editForm"  :rules="rules" label-width="120px"  ref="editForm">
          <el-form-item label="banner标题" prop="title" >
            <el-input v-model="editForm.title" auto-complete="off" placeholder="请输入banner标题"></el-input>
          </el-form-item>
          <el-form-item label="位置" prop="position" >
            <el-select v-model="editForm.position" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in position"
                :key="item.id"
                :label="item.value"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跳转链接" prop="jump_link" >
            <el-input v-model="editForm.jump_link" auto-complete="off" placeholder="请输入跳转链接"></el-input>
          </el-form-item>
          <el-form-item label="图片" prop="file_id"  style="text-align: left!important;">
            <el-upload
              class="upload-demo"
              action="#"
              :limit="100"
              :on-change="handleChange"
              :http-request="editUploadImg"
              list-type="picture"
              :file-list="fileList"
              :on-remove="handleEditRemove"
              ref="edit_upload"
              prop="file_id">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" style="color: red;font-size: 14px;margin-left: 8px" class="el-upload__tip">首页头部1920*845  移动端750*1175 其他页面1920*669 </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" :loading="editLoading" @click="editBanner('editForm')">保 存</el-button>
          <el-button size="small" @click="callOf('editForm')">取 消</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import {getList, changeStatus, changeSort, delBanner, addBanner, getInfo, editBanner} from '../../api/banner'
import {uploadImg, fileInfo} from '../../api'

export default {
  data () {
    return {
      editLoading: false,
      addLoading: false,
      tableData: [],
      page_size: 50,
      total: 0,
      page: 1,
      order_column: '',
      order_mode: '',
      dialogTitle: '',
      dialogAddVisible: false,
      dialogEditVisible: false,
      addForm: {
        title: '',
        position: 1,
        jump_link: '',
        file_id: ''
      },
      editForm: {
        title: '',
        position: 1,
        jump_link: '',
        file_id: ''
      },
      rules: {
        file_id: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ],
        position: [
          { required: true, message: '请选择位置', trigger: 'change' }
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ]
      },
      position: [
        {id: 1, value: '首页头部'},
        {id: 2, value: '游戏中心'},
        {id: 3, value: '视频中心'},
        {id: 4, value: '移动端'}
      ],
      fileList: [],
      file: {}
    }
  },
  mounted () {
    // 页面数据初始化表格数据
    this.setTableData()
  },
  methods: {
    // 分页大小切换回调
    handleSizeChange (val) {
      this.page_size = val
      this.setTableData()
    },

    // 页码切换回调
    handleCurrentChange (val) {
      this.page = val
      this.setTableData()
    },
    // 數據表格渲染
    setTableData () {
      let data = {
        page: this.page,
        page_size: this.page_size,
        order: this.order_column,
        order_mode: this.order_mode
      }
      getList(data).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.total = res.data.total
          this.tableData = res.data.data_list
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 更改状态
    handleChangeStatus (row, column, rowColumn) {
      changeStatus({
        id: row.id,
        column: column,
        status: row[rowColumn]
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.setTableData()
      })
    },
    // 更改排序
    changeSort (row) {
      changeSort({
        id: row.id,
        sort: row.sort
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.setTableData()
      })
    },
    // 排序改變回調
    changeColumnSort (field) {
      if (field.order) {
        this.order_column = field.prop
        this.order_mode = field.order === 'ascending' ? 'asc' : 'desc'
      } else {
        this.order_column = ''
        this.order_mode = ''
      }
      this.setTableData()
    },
    // 刪除banner
    del (id) {
      delBanner({
        id: id
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })

          this.setTableData()
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 上传前回调
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPng = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$notify({
          message: '上传图片必须为jpg或png 格式!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      if (!isPng) {
        this.$notify({
          message: '上传图片必须为jpg或png 格式!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      if (!isLt2M) {
        this.$notify({
          message: '上传图片大小不能超过 2MB!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      return isJPG && isLt2M
    },
    // 上传文件，获取文件流
    handleChange (file) {
      this.file = file.raw
    },
    // 文件上传
    uploadImg () {
      this.$refs.add_upload.clearFiles()
      // 创建表单对象
      let form = new FormData()
      // 后端接受参数 ，可以接受多个参数
      form.append('file', this.file)
      uploadImg(form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.addForm.file_id = res.data.file_id
          this.fileList = [{
            name: res.data.file_name,
            url: res.data.file_path
          }]
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.$refs.add_upload.clearFiles()
      })
    },
    // 编辑文件上传
    editUploadImg () {
      this.$refs.edit_upload.clearFiles()
      // 创建表单对象
      let form = new FormData()
      // 后端接受参数 ，可以接受多个参数
      form.append('file', this.file)
      uploadImg(form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.editForm.file_id = res.data.file_id
          this.fileList = [{
            name: res.data.file_name,
            url: res.data.file_path
          }]
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.$refs.edit_upload.clearFiles()
      })
    },
    // 文件删除回调
    handleRemove () {
      this.addForm.file_id = ''
      this.fileList = []
    },
    handleEditRemove () {
      this.editForm.file_id = ''
      this.fileList = []
    },
    // 关闭弹窗
    callOf (formName) {
      if (formName === 'addForm') {
        this.dialogAddVisible = false
        this.addForm.start_display_time = ''
        this.addForm.end_display_time = ''
        this.addForm.display_time = []
      } else if (formName === 'editForm') {
        this.editForm.start_display_time = ''
        this.editForm.end_display_time = ''
        this.editForm.display_time = []
        this.dialogEditVisible = false
      }
      if (formName) {
        this.fileList = []
        this.file = {}
        this.display_time = []
        this.$refs[formName].resetFields()
      }
    },
    // 新增弹窗
    addDialog () {
      this.dialogAddVisible = true
      this.dialogTitle = '新增banner'
    },
    // 展示时间范围选择
    changDisplayTime () {
      let value = this.display_time
      this.addForm.display_time = value
      this.addForm.start_display_time = value ? value[0] : ''
      this.addForm.end_display_time = value ? value[1] : ''
    },
    // 添加banner
    addBanner (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = this.addForm
          this.addLoading = true
          addBanner({
            title: formData.title,
            position: formData.position,
            file_id: formData.file_id,
            start_display_time: formData.start_display_time ? formData.start_display_time : '',
            end_display_time: formData.end_display_time ? formData.end_display_time : '',
            jump_link: formData.jump_link
          }).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.display_time = []
              this.setTableData()
              this.dialogAddVisible = false
              this.$refs[formName].resetFields()
              this.fileList = []
              this.addForm.display_time = []
              this.addForm.start_display_time = ''
              this.addForm.end_display_time = ''
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
            this.addLoading = false
          })
        }
      })
    },
    // 编辑弹窗
    editDialog (id) {
      getInfo({
        id: id
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.dialogEditVisible = true
          this.dialogTitle = '编辑banner'
          this.fileList = []
          this.editForm = res.data
          if (this.editForm.start_display_time) {
            this.editForm.display_time = [
              this.editForm.start_display_time,
              this.editForm.end_display_time
            ]
          } else {
            this.editForm.display_time = []
          }
          this.display_time = this.editForm.display_time
          fileInfo({id: this.editForm.file_id}).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.fileList = [{
                name: res.data.file_name,
                url: res.data.file_path
              }]
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 展示时间范围选择
    editChangDisplayTime () {
      let value = this.display_time
      this.editForm.display_time = value
      this.editForm.start_display_time = value ? value[0] : ''
      this.editForm.end_display_time = value ? value[1] : ''
    },
    // 保存编辑
    editBanner (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editLoading = true
          let data = this.editForm
          editBanner({
            id: data.id,
            title: data.title,
            position: data.position,
            jump_link: data.jump_link,
            start_display_time: data.start_display_time,
            end_display_time: data.end_display_time,
            file_id: data.file_id
          }).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.display_time = []
              this.setTableData()
              this.dialogEditVisible = false
              this.$refs[formName].resetFields()
              this.fileList = []
              this.editForm.display_time = []
              this.editForm.start_display_time = ''
              this.editForm.end_display_time = ''
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
            this.editLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/banner/index.vue